@for (part of parts(); track $index) {
  @if (isHighlightPart(part)) {
    <strong class="highlight">{{ part.highlight }}</strong>
  } @else {
    {{ part }}
  }
}
